const screenDesktop = window.matchMedia("(min-width: 992px)");
const screenTablet = window.matchMedia("(max-width: 991px) and (min-width: 577px)");
const screenMobile = window.matchMedia("(max-width: 576px)");

export default function currentDevice() {
    if (screenDesktop.matches) {
        return 'desktop'
    }
    if (screenTablet.matches) {
        return 'tablet'
    }
    if (screenMobile.matches) {
        return 'mobile'
    }
    return 'none';
}